import {ErrorMessage, Field, FieldArray, Form, Formik, FormikValues} from 'formik';
import React from 'react';
import { ErrorMsg, FlexRow, FormGroup, inputStyle, StyledLabel } from '../../../constants/styles';
import * as Yup from 'yup';
import { Button, DatePicker } from 'antd';
import Text from 'antd/lib/typography/Text';
import { PlanInput, FieldInputs, PlanType } from '../../../types';

type Props = {
  onSubmit: (data: PlanInput) => unknown;
  inputs?: FieldInputs;
  noFile?: boolean;
  plan_type: string | null;
};

const blankScenario = {
  value: '',
  status: 'neutral',
  error: '',
} as const;

const initialValues = {
  file: undefined,
  civil_status: undefined,
  underage_children_num: undefined,
  alive_parents_num: undefined,
  reactivation_wage: undefined,
  extra_weeks: undefined,
  retroactive_weeks: undefined,
  mod_40_scenarios: [blankScenario],
  investment_scenarios: [-1],
  edge_case: false,
  hard_start: undefined,
};

const basicPlanValidationSchema = Yup.object().shape({
  // file: Yup.mixed().required('Por favor sube un archivo').test('fileType', "Debes adjuntar un documento que tenga la extensión .pdf", value => value?.name.endsWith('.pdf')),
  civil_status: Yup.string().required('Selecciona el estado civil'),
  underage_children_num: Yup.number().min(0,"La cantidad de hij@s menores de edad en el retiro debe ser mayor que o igual a 0").required("La cantidad de hij@s mejores de edad en el retiro es requerida").transform(value => (isNaN(value) ? undefined : value)),
  alive_parents_num: Yup.number().min(0, "La cantidad de padres vivos debe ser mayor que o igual a 0").max(2, "La cantidad de padres vivos debe ser menor que o igual a 2").transform(value => (isNaN(value) ? undefined : value)),
  reactivation_wage: Yup.number().positive("El salario de reactivación debe ser mayor que 0").transform(value => (isNaN(value) ? undefined : value)).optional(),
  extra_weeks: Yup.number().positive("La cantidad de semanas extra debe ser mayor que 0").transform(value => (isNaN(value) ? undefined : value)),
  retroactive_weeks: Yup.number().positive("La cantidad de semanas retroactivas debe ser mayor que 0").transform(value => (isNaN(value) ? undefined : value)),
  edge_case: Yup.boolean(),
  investment_scenarios: Yup.array(),
  mod_40_scenarios: Yup.array(),
})

const civilStatusOptions = ['Casado', 'Soltero', 'Viudo', 'Divorciado'] as const;


export default function BasicPlanForm({plan_type, onSubmit, inputs, noFile = false}: Props) {
  console.log(plan_type)
  console.log(inputs ? "true" : "false")
  console.log(inputs)
  return (
    <Formik
      initialValues={inputs ? {
        file: null,
        ...inputs
      } : initialValues}
      enableReinitialize
      validationSchema={(plan_type === PlanType.DIAGNOSTIC || plan_type === PlanType.STUDY) ? null : basicPlanValidationSchema}
      onSubmit={(values, { resetForm }) => {
        onSubmit({
          ...values,
          plan_type: plan_type,
          planId: inputs?.planId,
        } as unknown as PlanInput);
        resetForm({values: initialValues})
      }}
    >
      {
        ({setFieldValue, values}) => {
          const { underage_children_num, retroactive_weeks, alive_parents_num, reactivation_wage, edge_case, extra_weeks }: FormikValues = values
          return <Form>
            {!noFile &&
            <FormGroup>
              <StyledLabel>
                Reporte de semanas cotizadas
              </StyledLabel>
              <input
                  id="file"
                  name="file"
                  type="file"
                  onChange={(ev => {
                    setFieldValue('file', ev.currentTarget.files![0])
                  })}
              />
              <ErrorMessage name="file">
                {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
              </ErrorMessage>
            </FormGroup>
            }
            <>
              <FormGroup>
                <StyledLabel>
                  Estado civil
                </StyledLabel>
                <div
                    id="civil_status_group"
                >
                  <div
                      role="group"
                      aria-labelledby="civil_status_group"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        marginTop: '5px'
                      }}
                  >
                    {
                      civilStatusOptions.map(option => (
                          <p style={{marginBottom: '0.1em'}}>
                            <Field
                                value={option}
                                type="radio"
                                name="civil_status"
                            />
                            <Text
                                style={{
                                  marginLeft: '5px'
                                }}
                            >
                              {option}
                            </Text>
                          </p>
                      ))
                    }

                  </div>
                </div>
                <ErrorMessage name="civil_status_group">
                  {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
                </ErrorMessage>
              </FormGroup>
              <FormGroup>
                <StyledLabel>
                  Número de hij@s menores de 16 en el retiro
                </StyledLabel>
                <Field
                    value={underage_children_num >= 0 ? underage_children_num : ""}
                    name="underage_children_num"
                    id="underage_children_num"
                    style={inputStyle}
                />
                <ErrorMessage name="underage_children_num">
                  {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
                </ErrorMessage>
              </FormGroup>
              <FormGroup>
                <StyledLabel>
                  Número de padres vivos
                </StyledLabel>
                <Field
                    value={alive_parents_num >= 0 ? alive_parents_num : ""}
                    name="alive_parents_num"
                    id="alive_parents_num"
                    style={inputStyle}
                />
                <ErrorMessage name="alive_parents_num">
                  {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
                </ErrorMessage>
              </FormGroup>
              <FormGroup>
                <StyledLabel>
                  Semanas extra
                </StyledLabel>
                <Field
                    value={extra_weeks >= 0 ? extra_weeks : ""}
                    name="extra_weeks"
                    id="extra_weeks"
                    style={inputStyle}
                />
                <ErrorMessage name="extra_weeks">
                  {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
                </ErrorMessage>
              </FormGroup>
            </>
            {plan_type !== PlanType.DIAGNOSTIC && plan_type !== PlanType.STUDY &&
            <>
              <FormGroup>
                <StyledLabel>
                  Salario de reactivación
                </StyledLabel>
                <Field
                    value={reactivation_wage >= 0 ? reactivation_wage : ""}
                    name="reactivation_wage"
                    id="reactivation_wage"
                    style={inputStyle}
                />
                <ErrorMessage name="reactivation_wage">
                  {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
                </ErrorMessage>
              </FormGroup>
            </>
            }
            {(plan_type === PlanType.RETROACTIVE || plan_type === PlanType.ORGINAL_RETROACTIVE) &&
            <>
              <FormGroup>
                <StyledLabel>
                  Semanas Retroactivas
                </StyledLabel>
                <Field
                    value={retroactive_weeks >= 0 ? retroactive_weeks : ""}
                    name="retroactive_weeks"
                    id="retroactive_weeks"
                    style={inputStyle}
                />
                <ErrorMessage name="retroactive_weeks">
                  {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
                </ErrorMessage>
              </FormGroup>
            </>
            }
            {plan_type !== PlanType.DIAGNOSTIC && plan_type !== PlanType.STUDY &&
            <>
              <FormGroup>
                <StyledLabel>
                  Escenarios de modalidad 40
                </StyledLabel>
                <FieldArray
                    name="mod_40_scenarios"
                    render={_arrayHelpers => (
                        <>
                          {
                            values?.mod_40_scenarios?.length ?
                                (values.mod_40_scenarios as number[]).map((_val, idx) => (
                                    <div
                                        key={`scenario-${idx}`}
                                        style={{marginTop: '5px'}}
                                    >
                                      <StyledLabel>
                                        {`Aportación Mod. 40 Escenario #${idx + 1}*: `}
                                      </StyledLabel>
                                      <Field
                                          type={"number"}
                                          name={`mod_40_scenarios.${idx}`}
                                          style={inputStyle}
                                      />
                                    </div>
                                )) : <></>

                          }
                        </>
                    )}
                />
              </FormGroup>
              <FormGroup>
                <Button
                    style={{
                      margin: '5px'
                    }}
                    onClick={() => {
                      console.log({values});
                      const scenarios = values.mod_40_scenarios ?? [];
                      setFieldValue('mod_40_scenarios', [...scenarios, blankScenario])
                    }}
                >
                  Agregar otro escenario
                </Button>
                <Button
                    onClick={() => {
                      if (values.mod_40_scenarios.length === 0) return;
                      const scenarios = values.mod_40_scenarios;
                      scenarios.pop();
                      setFieldValue('mod_40_scenarios', scenarios);
                    }}
                >
                  Quitar el último escenario
                </Button>
              </FormGroup>
            </>
            }

            {(plan_type === PlanType.BASIC || plan_type === PlanType.RETROACTIVE) &&
            <>
              <FormGroup>
                <StyledLabel>
                  Escenarios de inversión
                </StyledLabel>
                <FieldArray
                    name="investment_scenarios"
                    render={_arrayHelpers => (
                        <>
                          {
                            values?.investment_scenarios?.length && (
                                (values.investment_scenarios as number[



                                    ]).map((_val, idx) => (
                                    <div
                                        key={`scenario-${idx}`}
                                        style={{marginTop: '5px'}}
                                    >
                                      <StyledLabel>
                                        {`Escenario de inversión #${idx + 1}*: `}
                                      </StyledLabel>
                                      <Field
                                          type={"number"}
                                          name={`investment_scenarios.${idx}`}
                                          style={inputStyle}
                                      />
                                    </div>
                                ))
                            )
                          }
                        </>
                    )}
                />
              </FormGroup>
              <FormGroup>
                <Button
                    style={{
                      margin: '5px'
                    }}
                    onClick={() => {
                      console.log({values});
                      const scenarios = values.investment_scenarios ?? [];
                      setFieldValue('investment_scenarios', [...scenarios, blankScenario])
                    }}
                >
                  Agregar otro escenario
                </Button>
                <Button
                    onClick={() => {
                      if (values.investment_scenarios.length === 0) return;
                      const scenarios = values.investment_scenarios;
                      scenarios.pop();
                      setFieldValue('investment_scenarios', scenarios);
                    }}
                >
                  Quitar el último escenario
                </Button>
              </FormGroup>
              <FormGroup>
                <StyledLabel>
                  Inicio forzoso
                </StyledLabel>
                <DatePicker
                    onChange={val => {
                      console.log(val);
                      if (!val) return;
                      const formatted = val.format('DD/MM/YYYY');
                      console.log({formatted});
                      setFieldValue('hard_start', val.format('DD/MM/YYYY'));
                    }}
                />
              </FormGroup>
            </>
            }
            {plan_type !== PlanType.DIAGNOSTIC && plan_type !== PlanType.STUDY &&
            <FormGroup>
              <FlexRow>
                <Field
                    value={edge_case || false}
                    type="checkbox"
                    name="edge_case"
                    id="edge_case"
                />
                <StyledLabel>
                  Enviar a Finauta para revisión
                </StyledLabel>
              </FlexRow>
              <ErrorMessage name="edge_case">
                {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
              </ErrorMessage>
            </FormGroup>
            }
            <FormGroup>
              <Button
                  htmlType="submit"
                  type="primary"
              >
                Generar
              </Button>
            </FormGroup>
          </Form>;
        }
      }
    </Formik>
  );
}
